import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useAppSelector } from '../../../../store/storeHooks'
import { selectLoginStatus } from '../../../../login/loginSelectors'
import { Logger } from '../../../../../lib/logging'
import { LoginStatus } from '../../../../login/loginTypes'
import { MERCHANT_NEWS_ROUTE } from '../../../../../constants/routes'


export function MerchantAdminHome() {
    const navigate = useNavigate()
    const loginStatus = useAppSelector(selectLoginStatus)

    const logger = new Logger("merchant")

    useEffect(() => {
        if (loginStatus === LoginStatus.LOGGED_IN) {
            logger.info(`Navigating to: ${MERCHANT_NEWS_ROUTE}`)
            navigate(MERCHANT_NEWS_ROUTE)
        } else {
            logger.info("Not logged in [skip navigation]")
        }
    }, [loginStatus])

    return null
}
